import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAuth } from '../hooks';

export default function SuperAdminGuard({ children }) {
    const { practiceUser: { results } } = useSelector((state) => state.practiceUser);
    const { user } = useAuth();

    const currentUser = results.find((el) => el.user && el.user.id === user?.pk);
    const isSuperUser = currentUser?.user?.is_superuser;

    if (results.length > 0 && !isSuperUser) {
        return <Navigate to="/dashboard/permission-denied" replace />;
    }

    return <>{children}</>;
}

SuperAdminGuard.propTypes = {
    children: PropTypes.node,
};
